/* 
 * File: src/client/updateNotification/UpdateContent.js
 * Descrizione: Definisce il contenuto da visualizzare nella notifica di aggiornamento.
 */

export const updateMessage = "È disponibile una nuova versione dell'app.";
